export const isEmpty = (str) => {
    return typeof str === "undefined" || str === null || str === "";
}

export const isObjectEmpty = (obj) => {

    return obj === undefined || Object.keys(obj).length <= 0;
}

export const isArrayEmpty = (obj) => {

    return obj === undefined || obj.length <= 0;
}